import { getCMSLocale } from '@/modules/cms';
import {
  type CMSApiBase,
  type CMSGroupMode,
  type CMSImageBase,
  createCmsUrl,
} from './base';
import type { BonusMinDepV2 } from './bonuses';

export interface IBonus extends CMSApiBase {
  offerTitle: string;
  code: string;
  frequency?: string;
  wager?: number;
  itemImg: CMSImageBase;
  minDeps: BonusMinDepV2[];
  maxWinFs?: string;
  maxCashout?: string;
  specialNote?: string;
}

export const getWpBonusesCMSUrl = (lang: string) =>
  createCmsUrl({
    path: 'wp-bonuses',
    queryData: { populate: 'deep', ...getCMSLocale(lang) },
  });

export interface WpBonusGroup {
  id: number;
  bonuses: IBonus[];
  groupsInclude: string | null;
  groupsExclude: string | null;
  groupsIncludeMode: CMSGroupMode;
  groupsExcludeMode: CMSGroupMode;
}
